import { APP_WARNING, ERROR } from "../_constants/actionConstants";

const errorsInitialState = {
  errors: {}, // Normalized by errorId
  warnings: {}, // Normalized by warningId
};

export const reducer = (state = errorsInitialState, action) => {
  switch (action.type) {
    case ERROR.ADD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.newError.errorId]: action.newError,
        },
      };
    case ERROR.ACKNOWLEDGE_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.errorId]: {
            ...state.errors[action.errorId],
            isAcknowledged: true,
          },
        },
      };

    case APP_WARNING.ADD_WARNING: {
      const { newWarning } = action;
      return {
        ...state,
        warnings: {
          ...state.warnings,
          [newWarning.warningId]: { ...newWarning, isAcknowledged: false },
        },
      };
    }

    case APP_WARNING.ACKNOWLEDGE_WARNING: {
      const { warningId } = action;
      return {
        ...state,
        warnings: {
          ...state.warnings,
          [warningId]: {
            ...state.warnings[warningId],
            isAcknowledged: true,
          },
        },
      };
    }

    default:
      return state;
  }
};
